import { DomSanitizer } from '@angular/platform-browser';

import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Constants } from '@utils/constants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationModalComponent } from '@component/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-term-operator-modal',
  templateUrl: './term-operator-modal.component.html'
})
export class TermOperatorModalComponent {

  loading = true;
  selectedTermType: any;
  title: string;
  subTitle: string;
  messageCheck: string;
  confirmText: string;
  urlTerm: any;
  checkTermOperator: boolean;
  term_string_title: string;
  term_string_term: string;
  qtdTerm: number;
  termsSystem = [];
  termDisplayed: any = [];
  indexTerm = 0;
  haveThemeDark: boolean;
  dialog: MatDialog;
  params: any;

  // TODO: MOCK
  mock_html: any;
  mock_link: any;
  mock_text: any;

  constructor(
    public dialogRef: MatDialogRef<TermOperatorModalComponent>,
    private notificationService: NotificationsService,
    private sanitizer: DomSanitizer,
    private _render2: Renderer2,
    dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialog = dialog;
    if (this.data && this.data.messages) {
      this.title = this.data.messages.title ? this.data.messages.title : '';
      this.subTitle = this.data.messages.subTitle ? this.data.messages.subTitle : '';
      this.messageCheck = this.data.messages.messageCheck ? this.data.messages.messageCheck : '';
      this.confirmText = this.data.messages.confirmText ? this.data.messages.confirmText : 'Confirmar';
    }

    if (this.data && this.data.term) {
      this.selectedTermType = this.data.term.type_term;
    }
    switch (this.selectedTermType) {
      case Constants.TERM_OPERATOR_TYPES.PDF:
        const urlTerm = 'data:application/pdf;base64,' + this.data.term.pdf;
        this.urlTerm = this.sanitizer.bypassSecurityTrustResourceUrl(urlTerm);
        // debugger
        // TODO: MOCK API DE TERMOS DAYCOVAL
        this.mock_link = this.data.term.mock_link;
        this.mock_html = this.data.term.mock_html;
        this.mock_text = this.data.term.mock_text;
        this.termsSystem.push(this.urlTerm);
        this.termsSystem.push(this.term_string_term);
        this.termsSystem.push(this.mock_text);
        this.termsSystem.push(this.mock_link);
        this.qtdTerm = this.termsSystem.length;
        this.indexTerm = 1;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
        break;
      case Constants.TERM_OPERATOR_TYPES.TEXT:
        this.term_string_title = Constants.TERM_OPERATOR_TYPE_STRING_TITLE;
        this.term_string_term = Constants.TERM_OPERATOR_TYPE_STRING_TERM;
        this.loading = false;
        break;
      case Constants.TERM_OPERATOR_TYPES.URL:
        if (document.getElementsByClassName('darkTheme')[0]) {
          this._render2.removeClass(document.body, 'darkTheme');
          this.haveThemeDark = true;
        }
        this.termsSystem = this.data.term.term;
        this.qtdTerm = this.termsSystem.length;
        this.indexTerm = 0;
        this.params = { user: this.data.account, keys: [] };
        this.showTermDisplayed(this.indexTerm);
        break;
      default:
        this.notificationService.warn('', Constants.TERM_OPERATOR_ERROR);
        this.loading = false;
        break;
    }
  }

  showTermDisplayed(indexTerm) {
    if (this.termsSystem && this.termsSystem.length > 0 && indexTerm < this.termsSystem.length) {
      if (this.termsSystem[indexTerm].is_required && this.termsSystem[indexTerm].accept) {
        this.indexTerm++;
      }
      this.termDisplayed = this.termsSystem[indexTerm];
      this.termDisplayed.numberOfTerm = indexTerm + 1;
      if (this.termDisplayed.type_term === Constants.TERM_OPERATOR_TYPES.URL) {
        this.termDisplayed.term = this.sanitizer.bypassSecurityTrustResourceUrl(this.termsSystem[indexTerm].term);
      }
      this.confirmText = indexTerm === this.termsSystem.length - 1 ? 'Confirmar' : 'Próximo';
    }
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }


  close() {
    if (this.termDisplayed.type_term === Constants.TERM_OPERATOR_TYPES.URL) {
      this.openModalConfirm();
    } else {
      this.dialogRef.close(false);
    }

  }

  confirm() {
    this.loading = true;
    if (this.selectedTermType === Constants.TERM_OPERATOR_TYPES.URL) {
      this.params.keys.push(this.termsSystem[this.indexTerm].id);
      if (this.indexTerm < this.termsSystem.length && this.termDisplayed.numberOfTerm < this.termsSystem.length) {
        this.termsSystem[this.indexTerm].is_signed = this.checkTermOperator;
        this.indexTerm++;
        this.checkTermOperator = false;
        this.showTermDisplayed(this.indexTerm);
      } else {
        if (this.haveThemeDark) {
          this._render2.addClass(document.body, 'darkTheme');
          this.haveThemeDark = false;
        } else {
          this._render2.removeClass(document.body, 'darkTheme');
        }
        this.dialogRef.close(this.params);
      }
    } else {
      this.dialogRef.close(this.checkTermOperator);
    }
  }

  openModalConfirm() {
    const dialogConfig = this.dialog.open(ConfirmationModalComponent, { panelClass: Constants.NORMAL_MODAL });
    dialogConfig.componentInstance.title = 'Atenção';
    dialogConfig.componentInstance.content = Constants.WORKSPACE_MSG032;
    dialogConfig.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(false);
      }
    });
  }

  // TODO: MOCK API DE TERMOS DAYCOVAL
  mockChangeTerm(direction: number) {
    if (direction === 0 && this.indexTerm > 1) {
      this.indexTerm--;
    } else if (direction === 1 && this.indexTerm < this.termsSystem.length) {
      this.indexTerm++;
    }
  }

}
